import React, {useState} from 'react';
import {getAllUsers, getCumulativeResult, getTotalResponseCount} from "../apis/research-api";
import {useDispatch} from "react-redux";
import {STORE_USERS} from "../action-lists";
import {useHistory} from "react-router-dom";

export const ResearcherHeader = (props) => {
    const history = useHistory();
    const users = props.users;
    const dispatch = useDispatch();
    const [tabOne, setTabOne] = useState(true);
    const [tabTwo, setTabTwo] = useState(false);
    const [count, setCount] = useState(0);
    const [cumulativeResponse, setCumulativeResponse] = useState({});
    const [wait, setWait] = useState(true);
    const [responseStatus, setResponseStatus] = useState(false);


    const getAggregatedResult = async () => {
        return await getCumulativeResult();
    }

    const seeIndividualResponse = (i) => {
        if (responseStatus || users !== null) {
            history.push({
                pathname: '/user-report',
                state: {user: users[i]}
            });
        } else {
            window.alert("Please wait, we are fetching survey response");
        }
    }

    const onTabClickHandler = (tabIdentifier) => {
        if (tabIdentifier === 'tab1') {
            setTabOne(true);
            setTabTwo(false);
        } else {
            setTabTwo(true);
            setTabOne(false);
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(async () => {
        if (tabOne) {
            const res = await getTotalResponseCount();
            res.text().then(data => setCount(parseInt(data)));
            const users = await getAllUsers();
            dispatch({
                users: users,
                type: STORE_USERS
            });
            setResponseStatus(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabOne]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(async () => {
        if (tabTwo) {
            const res = await getAggregatedResult();
            setCumulativeResponse(res);
            setWait(false);
        }
    }, [tabTwo]);

    const items = [];

    for (let i = 0; i < count; i++) {
        items.push(
            <div className='individual-report-btn' key={i}>
                <button onClick={() => seeIndividualResponse(i)}>Response {i + 1}</button>
            </div>
        )
    }

    const goToHome =()=> {
        history.push("/")
    };

    return (
        <div className='researcher-header-container'>
            <div className='back-to-home' onClick={goToHome}>
                Home
            </div>
            <div className='researcher-header'>
                <div className='tab-one' onClick={() => onTabClickHandler('tab1')}>
                    <h5>All Responses ({count}) </h5>
                </div>

                <div className='tab-two' onClick={() => onTabClickHandler('tab2')}>
                    <h5>Cumulative result</h5>
                </div>
            </div>
            {
                tabOne &&
                <div className='individual-reports'>
                    {
                        items
                    }
                </div>
            }
            {
                tabTwo &&
                <div className='cumulative-report-container'>
                    {
                        wait ?
                            <p style={{color: 'green'}}>Please wait ...</p>
                            : <>
                                <h5>Below is the aggregated analysis of {count} participants</h5>
                                <div className='category-scores'>
                                    <p><b>RIA</b> : {cumulativeResponse.ria}</p>
                                    <p><b>RIC</b> : {cumulativeResponse.ric}</p>
                                    <p><b>RIE</b> : {cumulativeResponse.rie}</p>
                                    <p><b>SIA</b> : {cumulativeResponse.sia}</p>
                                    <p><b>SIC</b> : {cumulativeResponse.sic}</p>
                                    <p><b>SIE</b> : {cumulativeResponse.sie}</p>
                                    <p><b>SIR</b> : {cumulativeResponse.sir}</p>
                                    <p><b>Others</b> : {cumulativeResponse.inCompatible}</p>
                                </div>

                                <div className='conclusion'>
                                    <p><i>Completely Compatible: {parseInt(cumulativeResponse.sia)}</i></p>
                                    <p><i>Relatively Compatible: {parseInt(cumulativeResponse.sie) +
                                    parseInt(cumulativeResponse.sir) + parseInt(cumulativeResponse.sic)
                                    }</i></p>
                                    <p><i>InCompatible: {parseInt(cumulativeResponse.inCompatible) +
                                    parseInt(cumulativeResponse.ria) + parseInt(cumulativeResponse.ric)
                                    + parseInt(cumulativeResponse.rie)
                                    }</i></p>
                                </div>
                            </>
                    }
                </div>
            }
        </div>
    );
}